/**
 * The current slide's speaker notes, over the bottom of the slide (MYD-497).
 * For presenting on ONE screen, where there is no second window for the
 * presenter view; toggled with N. Large and high-contrast, because it is read
 * at a glance from arm's length.
 */
interface SpeakerNotesOverlayProps {
	notes: string
}

export function SpeakerNotesOverlay({ notes }: SpeakerNotesOverlayProps) {
	return (
		<div
			className="pointer-events-none absolute inset-x-0 bottom-16 z-10 flex justify-center px-6"
			role="note"
			aria-label="Speaker notes"
		>
			<div className="max-h-[40dvh] w-full max-w-4xl overflow-y-auto rounded-xl bg-black/85 px-6 py-4 text-lg leading-relaxed text-white shadow-2xl">
				{notes.trim() ? (
					<p className="whitespace-pre-wrap">{notes}</p>
				) : (
					<p className="text-white/50">No notes for this slide.</p>
				)}
			</div>
		</div>
	)
}

export default SpeakerNotesOverlay
